import combinedGACall from '../combinedGACall';

export default (action) =>
	combinedGACall({
		category: 'Get started',
		action,
	});
